/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_6_AInputs */

const en_cp_faq_6_a = /** @type {(inputs: Cp_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They don't compete — many leads hold both. Vendor clubs bring credits and community; Bystep brings a proof loop lecturers can grade and a path to P2MW/PKM. Our ask: one build night and one class/community per semester.`)
};

const id_cp_faq_6_a = /** @type {(inputs: Cp_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak bersaing — banyak lead merangkap. Klub vendor memberi kredit dan komunitas; Bystep memberi loop bukti yang bisa dinilai dosen dan jalur ke P2MW/PKM. Syarat kami: 1 build night dan 1 kelas/komunitas per semester.`)
};

/**
* | output |
* | --- |
* | "They don't compete — many leads hold both. Vendor clubs bring credits and community; Bystep brings a proof loop lecturers can grade and a path to P2MW/PKM. O..." |
*
* @param {Cp_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_6_a = /** @type {((inputs?: Cp_Faq_6_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_6_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_6_a(inputs)
	return en_cp_faq_6_a(inputs)
});